<template>
  <div>
    <!-- RECEIPT PREVIEW -->
    <div class="receipt" ref="printSection">

      <div class="text-center logo-image mb-3 ">
        <img  v-if="order && order.image && order.image.trim().length"  alt="" style="max-width: 150px;"  class="text-center" width="100%" height="auto"  v-bind:src="'/api/image/get/menu/' + order.image"  />    
      </div>

      <h5 class="text-center">*** REÇU ***</h5>
      <p class="text-center">Merci pour votre visite !</p>


      <div class="row mb-1">
        <span class="label">Date :</span> <span class="value">{{ order.submissionDate }}</span>
      </div>
      <div v-if="order && order.name" class="row mb-1">
        <span class="label">Client :</span> <span class="value">{{ order.name }}</span>
      </div>
      <div v-if="order && order.phone" class="row mb-2">
        <span class="label">Téléphone :</span> <span class="value">{{ order.phone }}</span>
      </div>
      <div v-if="order && order.address" class="row address mb-2">
        <span class="value">{{ order.address }}</span>
      </div>

      <hr />

      <!-- ITEMS -->
      <table class="items">
        <tbody>
          <tr v-for="(item, i) in groupedItems" :key="i">
            <td class="item-name">{{ item.quantity }}x {{ item.name }}</td>
            <td class="item-price">{{ item.total }}</td>
          </tr>
        </tbody>
      </table>

      <hr />

      <!-- TOTAL -->
      <table class="total">
        <tbody>
          <tr>
            <td class="total-price text-uppercase">Total à payer</td>
            <td class="item-price">{{ subtotal }}</td>
          </tr>
        </tbody>
      </table>

      <hr />

      <!-- QR CODE -->
      <div class="text-center mt-3 ">
        <qrcode-vue :value="qrValue" :size="120" level="H" render-as="svg" />
      </div>

      <p class="text-center mt-3 mb-0">*** MERCI ET À BIENTÔT ! ***</p>
    </div>

    <!-- PRINT BUTTON -->
    <div class="text-center no-print">
      <button @click="printReceipt">Imprimer le reçu</button>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "Receipt",
  components: { QrcodeVue },
  props: {
    order: { type: Object, required: true },
  },
  computed: {
    groupedItems() {
      return this.order.lines.submitted.items.map((item) => ({
        name: item.name,
        quantity: item.cartItemQuantity,
        total: item.cartItemSubTotal,
      }));
    },
    subtotal() {
      return this.order.lines.submitted.cartTotal;
    },
    qrValue() {
      return JSON.stringify({
        id: this.order.id,
        date: this.order.submissionDate,
        telephone: this.order.phone,
        client: this.order.name,
        table: this.order.tableNumber,
        menu: this.order.menuCode,
      });
    },
  },
  methods: {

    printReceipt() {
  const qrCanvas = this.$refs.printSection.querySelector("canvas");
  let qrImageHTML = "";

  if (qrCanvas) {
    const qrDataUrl = qrCanvas.toDataURL("image/png");
    qrImageHTML = `<img src="${qrDataUrl}" style="display:block; margin:16px auto 0 auto; width:120px; height:120px;" />`;
  }

  let printContents = this.$refs.printSection.innerHTML;

  if (qrImageHTML) {
    printContents = printContents.replace(/<canvas[\s\S]*?<\/canvas>/g, qrImageHTML);
  }

  const w = window.open("", "_blank", "width=1020,height=600");
  w.document.write(`
    <html>
      <head>
        <title>Reçu</title>
        <style>
          @page { size: 80mm auto; margin: 0; }
          body {
            font-family: Arial, sans-serif;
            font-weight: 500;
            color: #000;
            font-size: 14px;
            margin: 0;
            padding: 0;
          }
          .receipt {
            width: 78mm;
            margin: 0 auto;
            padding: 4mm;
            overflow: visible;
          }
          h5, p, span, td {
            color: #000;
            font-weight: 500;
            font-size: 14px;
          }
          .text-center { text-align: center; }
          hr {
            border-top: 2px dashed #000;
            margin: 10px 0;
          }
          .row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 2px;
          }

          .total-price{
            text-transform: uppercase;
          }

          .row.address {
            margin-top: 10px;
          }

          .logo-image{
            margin-bottom: 12px;
          }

          .label { font-weight: 500; }
          .value { font-weight: 500; }
          table.items, table.total {
            width: 100%;
            border-collapse: collapse;
          }
          table td {
            padding: 2px 0;
            vertical-align: top;
          }
          .item-name { width: 60%; }
          .item-price { width: 40%; text-align: right; }
          canvas { display: block; margin: 0 auto; }
          button {
            font-size: 16px;
            padding: 6px 12px;
            font-weight: 500;
            cursor: pointer;
          }
          @media print {
            .no-print { display: none; }
          }
        </style>
      </head>
      <body>${printContents}</body>
    </html>
  `);
  w.document.close();

  w.onload = () => {
    setTimeout(() => {
      w.focus();
      w.print();
      w.close();
    }, 500);
  };
}

  },
};
</script>

<style scoped>
/* Preview styling without Bootstrap */
.receipt {
  border: 1px dashed #ccc;
  background: #fff;
  width: 78mm;
  margin: auto;
  padding: 4mm;
  font-family: Arial, sans-serif;
  font-weight: 500;
  font-size: 10px;
  color: #000;
}
.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
}
.label, .value, td, span, strong {
  font-weight: 500;
  font-size: 14px;
  color: #000;
}
table.items, table.total {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 4px;
}
.item-name { width: 50%; }
.item-price { width: 50%; text-align: right; }
.text-center { text-align: center; }
hr { border-top: 2px dashed #000; margin: 4px 0; }
</style>
